import request from '@/utils/request'
const baseUrl = 'https://www.leadtopone.cn/prod-api';
export function saveInfo(data) {
    return request({
        url: baseUrl + `/system/company/info/add`,
        method: 'post',
        data
    })
}